"use client"

import {
  useRef 
} from "react"
import {
  useButton 
} from "react-aria"

import {
  useStyle 
} from "@/classify"
import defaultClasses from "./button.module.css"

const getRootClassName = (priority, negative) => `root_${priority}Priority${negative ? "Negative" : ""}`

const Button = (props) => {
  const {
    children,
    classes: propClasses,
    priority = "normal",
    type = "butotn",
    negative = false,
    disabled = false,
    onPress,
    loading = false,
    ...restProps
  } = props

  const buttonRef = useRef()

  const {
    buttonProps 
  } = useButton(
    {
      isDisabled: disabled,
      onPress,
      ...restProps,
    },
    buttonRef
  )

  const classes = useStyle(defaultClasses, propClasses)
  const rootClassName = classes[getRootClassName(priority, negative)]

  const contentClass = loading ? classes.contentLoading : classes.content

  return (
    <button
      ref={buttonRef}
      className={rootClassName}
      {...buttonProps}
      type={type}
      {...restProps}
    >
      <span className={contentClass}>{children}</span>
    </button>
  )
}

export default Button
